import type { Ctx } from "../../types";
import { Action } from "gg-wf-scripts";
import { toast } from "../../toast";

export const resend_invite: Action<Ctx, { id?: string }> = async (
  { sb },
  data,
  params,
) => {
  const user_id = data.id ?? params.get("id");
  if (!user_id) {
    return { ok: false, error: "Missing id on row record or in URL" };
  }
  const { error } = await sb.functions.invoke(
    `api/users/${user_id}/resend-invite`,
    { method: "POST" },
  );
  if (error) {
    toast({ variant: "error", text: "Invite resend failed. Try again" });
    return { ok: false, error: error.message };
  }
  toast({ variant: "success", text: "Invite email sent!" });
  return { ok: true };
};
